module.exports = __webpack_public_path__ + "img/model_20_zh.cba4212c.jpg";